import React, { Component } from 'react';
import { provideHooks } from 'redial';

import { getDashboard } from 'store/dashboard/dashboard';
import { homePageLoaded } from 'store/home/home';
import { getLastSearch } from 'store/lastSearch/lastSearch';
import HomePage from 'HomePage/HomePage';

const hooks = {
  fetch: ({ routeEnter, dispatch, cookies, locale }) => routeEnter ? dispatch(getLastSearch({ cookies, locale })) : null,
  authenticated: ({ routeEnter, dispatch, locale, cookies }) => routeEnter ? dispatch(getDashboard(locale, cookies.JobseekerSessionId)) : null,
  pageLoad: ({ routeEnter, dispatch }) => routeEnter ? dispatch(homePageLoaded()) : null
};

@provideHooks(hooks)
export default class Home extends Component {

  render() {
    return <HomePage />;
  }

}



/** WEBPACK FOOTER **
 ** ./app/handlers/Home.js
 **/